module.exports = "<button #stripeBtn mat-raised-button [disabled] = \"disable\"> {{textCopy}} </button>\r\n"